<template>
    <p-dialog
        :visible="false"
        @update:visible="toggle"
        modal
        dismissableMask
        class="app-company-status-dialog"
    >
        <template #header>
            <div></div>
        </template>

        <div class="app-company-status-dialog--content">
            <template v-if="model.showCompanyStatusModal === 'comingSoon'">
                <img src="/img/home/clock.svg" />
                <div class="app-company-status-dialog--content-heading">
                    <i18n-t keypath="common.comingSoon" />
                </div>
                <div class="app-company-status-dialog--content-description">
                    <span style="visibility: hidden">
                        Coming Soon Coming Soon Coming Soon Coming
                    </span>
                </div>
            </template>
            <template
                v-else-if="
                    currentCompany.companyDto?.status.id === enumCompanyRole.DEACTIVATED
                "
            >
                <div class="app-company-status-dialog--content-heading">
                    <i18n-t keypath="companyStatusPopup.declined" />
                </div>
            </template>
            <template
                v-else-if="
                    currentCompany.companyDto?.status.id ===
                    enumCompanyRole.AWAITING_APPROVAL
                "
            >
                <img src="/img/home/clock.svg" />
                <div class="app-company-status-dialog--content-heading">
                    <i18n-t keypath="companyStatusPopup.in_progress" />
                </div>
                <div class="app-company-status-dialog--content-description">
                    <i18n-t keypath="companyStatusPopup.in_progress_description" />
                </div>
            </template>
            <template v-else-if="model.isAwaitingAccountConfirmation">
                <img src="/img/home/company-details.svg" />
                <div class="app-company-status-dialog--content-heading">
                    <i18n-t keypath="companyStatusPopup.welcome_description" />
                </div>
            </template>
            <template v-else>
                <div class="app-company-status-dialog--content-heading">
                    <i18n-t
                        keypath="companyStatusPopup.limited_admin_description"
                        v-if="model.isLimitedAdmin"
                    />
                    <i18n-t
                        keypath="companyStatusPopup.description"
                        v-else-if="model.showCompanyStatusModal === 'default'"
                    />
                    <i18n-t
                        keypath="companyStatusPopup.welcome_description"
                        v-else-if="model.showCompanyStatusModal === 'welcome'"
                    />
                </div>
            </template>
        </div>

        <template #footer v-if="model.showCompanyStatusModal !== 'comingSoon'">
            <router-link
                to="/auth/my-carconnex/my-account/company-info"
                v-slot="{ navigate }"
            >
                <p-button
                    @click="
                        () => {
                            navigate();
                            model.showCompanyStatusModal = false;
                        }
                    "
                    class="p-text-uppercase"
                    :label="i18n.t('companyStatusPopup.button')"
                    autofocus
                />
            </router-link>
        </template>
    </p-dialog>
</template>
<script lang="ts">
import { AppCompanyStatusDialogComponent } from "./app-company-status-dialog";
export default AppCompanyStatusDialogComponent;
</script>

<style lang="scss">
@import "../../../shared/styles/mixins";

.app-company-status-dialog .p-dialog-header {
    padding-bottom: 0 !important;
}

.app-company-status-dialog {
    max-width: c-rem(440);
}

.app-company-status-dialog .p-dialog-footer {
    text-align: center;
}

.app-company-status-dialog--content {
    text-align: center;
}

.app-company-status-dialog--content-heading {
    @include fontPoppins(18, 600);
    line-height: c-rem(24);
    letter-spacing: 0;
    color: $color-bg-8;
}
</style>
